import { Component, OnInit } from '@angular/core';
import { FiltrosCustosService } from '../../../../filters/filtros-custos.service';
import { CustoconsumoService } from './custoconsumo.service';

@Component({
  selector: 'app-custoconsumo',
  templateUrl: './custoconsumo.component.html',
  styleUrl: './custoconsumo.component.css',
})
export class CustoconsumoComponent implements OnInit {
  consumos: any[] = [];
  totalRecords: number = 0;
  loading: boolean = false;

  dataInicio: string = '';
  dataFim: string = '';
  instancia: string = '';

  constructor(
    private consumoService: CustoconsumoService,
    private filterService: FiltrosCustosService
  ) {}

  ngOnInit() {
    this.loading = true;

    this.getFiltros();
  }

  getFiltros() {
    this.filterService.currentInstancia.subscribe((instancia) => {
      this.instancia = instancia;
      this.loadConsumo({
        first: 0,
        rows: 10,
        sortField: 'cdEmpresaErp',
        sortOrder: 1,
      });
    });

    this.filterService.currentDataInicio.subscribe((inicio) => {
      this.dataInicio = inicio;
      this.loadConsumo({
        first: 0,
        rows: 10,
        sortField: 'cdEmpresaErp',
        sortOrder: 1,
      });
    });

    this.filterService.currentDataFim.subscribe((fim) => {
      this.dataFim = fim;
      this.loadConsumo({
        first: 0,
        rows: 10,
        sortField: 'cdEmpresaErp',
        sortOrder: 1,
      });
    });
  }

  loadConsumo(event: any) {
    if (this.instancia != '' && this.dataInicio != '' && this.dataFim != '') {
      this.loading = true;
      const sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
      this.consumoService
        .getConsumo(
          event.first / event.rows,
          event.rows,
          event.sortField,
          sortDirection,
          this.instancia,
          this.dataInicio,
          this.dataFim
        )
        .subscribe((data) => {
          this.consumos = data.content;
          this.totalRecords = data.totalElements;
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  }
}
